import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectUsersState = (state) => state.users || initialState;

export const getAllMarketUsers = createSelector(
  [selectUsersState],
  (usersState) => usersState.usersInfo
);

export const selectMarketUser = createSelector(
  [selectUsersState],
  (usersState) => usersState.user
);

export const selectUserActivateInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.userActivateInfo
);

export const selectUserDeactivateInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.userDeactivateInfo
);

export const selectVerifyEmailAndActivateInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.verifyEmailAndActivateInfo
);

export const selectUpdateUserInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.updateUserInfo
);

export const selectUserSearchHistory = createSelector(
  [selectUsersState],
  (usersState) => usersState.searchHistoryInfo
);

export const selectProfileUploadInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.profileUplaodInfo
);

export const selectCreatorAnalytics = createSelector(
  [selectUsersState],
  (usersState) => usersState.creatorAnalyticsInfo
);

export const selectCreatorChart = createSelector(
  [selectUsersState],
  (usersState) => usersState.creatorChartInfo
);

export const selectMarketplaceAnalytics = createSelector(
  [selectUsersState],
  (usersState) => usersState.marketplaceAnalyticsInfo
);

export const selectMarketplaceChart = createSelector(
  [selectUsersState],
  (usersState) => usersState.marketplaceChartInfo
);

export const selectCompanyUsersByStatus = createSelector(
  [selectUsersState],
  (usersState) => usersState.companyUsersByStatusInfo
);
